import styled from 'styled-components/macro';
import {TABLET_BREAKPOINT} from "../../app/constants";

export const StyledTimes = styled.div`
  max-height: calc(100vh - 363px);
  @media (max-width: ${TABLET_BREAKPOINT}px) {
    max-height: calc(100% - 80px);
  }
`;
